import isURL from 'validator/lib/isURL';
// The purpose of this service is to assist validation by adding custom rules that were removed during vee-validate 3 upgrade
var ValidationService = /** @class */ (function () {
    function ValidationService() {
    }
    ValidationService.prototype.isUrl = function (link, requireProtocol) {
        if (requireProtocol === void 0) { requireProtocol = true; }
        if (!link) {
            return false;
        }
        return isURL(link, { require_protocol: requireProtocol });
    };
    ValidationService.prototype.isPhoneNumber = function (phoneNumber) {
        if (!phoneNumber) {
            return false;
        }
        var phoneRegex = /^([0-9+\(\)\/\+ \-]*)$/;
        return phoneRegex.test(phoneNumber);
    };
    return ValidationService;
}());
export default ValidationService;
